import { HStack, InlineEdit, NewButton, Text } from '@eluve/components';

interface ChatHeaderProps {
  isLoading: boolean;
  showHistoryButton?: boolean;
  onCreateThread: () => void;
  onSelectThread?: (threadId: string | null) => void;
  threadTitle?: string;
  onThreadTitleChange?: (threadId: string, newTitle: string) => void;
  threadId?: string;
}

export const ChatHeader = ({
  isLoading,
  showHistoryButton = false,
  onCreateThread,
  onSelectThread,
  threadTitle,
  onThreadTitleChange,
  threadId,
}: ChatHeaderProps) => {
  return (
    <HStack
      justify="between"
      className="border-b border-border-primary px-2 pb-3 pr-4"
    >
      <HStack gap={2} wFull={false}>
        <NewButton
          disabled={isLoading}
          icon={{ name: 'SquarePen' }}
          onClick={onCreateThread}
          type="ghost"
          size="m"
          text="New chat"
        />
        {showHistoryButton && (
          <NewButton
            disabled={isLoading}
            icon={{ name: 'History' }}
            onClick={() => onSelectThread?.(null)}
            type="ghost"
            text="History"
            size="m"
          />
        )}
      </HStack>
      {threadId && threadTitle && (
        <HStack justify="end" className="min-w-0 max-w-2xl">
          <InlineEdit
            className="w-full justify-end"
            value={threadTitle}
            onSave={(newTitle) =>
              threadId && onThreadTitleChange?.(threadId, newTitle)
            }
            isLoading={isLoading}
            placeholder="Thread title"
            maxLength={100}
          >
            <Text
              size="md"
              weight="semibold"
              color="primary"
              className="truncate"
            >
              {threadTitle}
            </Text>
          </InlineEdit>
        </HStack>
      )}
    </HStack>
  );
};
